import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type StandardandCustomParamterDetails } from '../services/getStandardandCustomParamterService'

export interface SchdulerListDataState {
  isLoading: boolean
  loadingError: string | undefined
  StandardandCustomListData: StandardandCustomParamterDetails[] | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: SchdulerListDataState = {
  isLoading: true,
  loadingError: undefined,
  StandardandCustomListData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const StandardandCustomListingDataState = createSlice({
  name: 'StandardandCustomListData',
  initialState,
  reducers: {
    StandardandCustomListDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        StandardandCustomListData: undefined,
        httpStatus: 0
      }
    },
    StandardandCustomListDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        StandardandCustomListData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    StandardandCustomListDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        StandardandCustomListData: undefined
      }
    }
  }
})

// Actions to export
export const {
  StandardandCustomListDataLoadingAction,
  StandardandCustomListDataUpdateAction,
  StandardandCustomListDataErrorAction
} = StandardandCustomListingDataState.actions

export default StandardandCustomListingDataState.reducer
